import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import utils from '../../../util/Util';
import { Row, Col, Input, FormGroup, Label } from 'reactstrap';
import DatePicker from 'react-datepicker';
import { Formik, Form } from "formik";
import consts from '../../../util/Consts';
import { POStatusReport } from '../../../redux/actions/HttpRequest';
import LoadingDialog from '../../../components/loadingDialog/LoadingDialog';
import PopupDialog from '../../../components/popupDialog/PopupDialog';
import './PoReport.css';

class PurchaseOrderReport extends PureComponent {

    constructor(props) {
        super(props);
        const isSessionEmpty = sessionStorage.length;
        if (isSessionEmpty === 0) {
            this.props.history.replace("/");
        }
        this.state = {
            reportGenerated: false,
            ShowEmailMsg: false,
            DateError: false,
            userData: JSON.parse(sessionStorage.getItem(consts.sessionVariables.UserData))
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.POStatusReport && nextProps.POStatusReport.data && nextProps.POStatusReport.data !== this.props.POStatusReport.data) {
            const { data, success, message } = nextProps.POStatusReport.data;
            if (success && data) {

                if(!this.state.usingEmail)  utils.downloadFile(data, this.state.fileType, 'POReport_');
                else   this.setState({ usingEmail: false });

                this.setState({ isFetching: false, reportGenerated: !this.state.reportGenerated}, () => {                  
                    setTimeout( () =>{ this.setState({ ShowEmailMsg: false }) }, 15000)
                });

            } else if ((!success && !data && message === window.MailMsg) ) {


                this.setState({ isFetching: false, showModal: true, popupMessage: message, popupTitle: false, PopupEmail: true, ShowEmailMsg: true }, () => {
                    this.timeout = setTimeout(() => {
                        this.setState({ showModal: false });
                    }, 300000) // 5 min
                });
            }  else if(success && message){
                let request = this.state.apiRequest;
                request.email = '';
                
                this.setState({ isFetching: false,showModal: true, popupMessage: message, popupTitle: false, PopupEmail: false, apiRequest: request }, () => {
                    this.timeout = setTimeout(() => {
                        this.setState({ showModal: false });
                    }, 300000) // 5 min
                });
            }else {

                this.setState({ isFetching: false, showModal: true, popupMessage: "No data found", popupTitle: false, PopupEmail: false }, () => {
                    this.timeout = setTimeout(() => {
                        this.setState({ showModal: false });
                    }, 300000) // 5 min
                });

            }
        }
    }

    setDate = (date, stateArray, setFieldValue) => {
        this.setState({ DateError: false });
        setFieldValue(stateArray, date);
    }

    getFromattedDate = d => {
        let mm = d.getMonth() + 1;
        let dd = d.getDate();
        let yy = d.getFullYear();
        return yy + '-' + mm + '-' + dd;
    }

    popupSubmit = email => {
        this.setState({ showModal: false, usingEmail: email ? true : false, PopupEmail: false, isFetching: true });
        clearInterval(this.timeout);
        if(email)   {
            let request = this.state.apiRequest;
            request.email = email;
            debugger
            this.props.dispatch(POStatusReport.request(request));
        }
    }

    handleModal = () => {
        let showModal = this.state.showModal;
        this.setState({ showModal: !showModal, PopupEmail: false });
        if (showModal && this.timeout) clearInterval(this.timeout);
    }

    onSubmit = (values, { setSubmitting }) => {
        setSubmitting(false);
        const { userData } = this.state;

        var StartDatee = Date.parse(values.StartDatee);
        var EndDatee = Date.parse(values.EndDatee);

        // adding all report status if none is selected
        if (!values.reportStatus.length) {
            consts.PoStatusOptions.map(ob => values.reportStatus.push(ob.value));
        }
        debugger
        if (StartDatee && EndDatee && StartDatee > EndDatee) {
            this.setState({ DateError: true, DateMsg: window.DateValidMsg });
        }else if (!values.EndDatee && !values.StartDatee) {
            this.setState({ DateError: true, DateMsg: window.NoEndStartDateMsg });
        }else if (!values.StartDatee) {
            this.setState({ DateError: true, DateMsg: window.NoStartDateMsg });
        }else if (!values.EndDatee) {
            this.setState({ DateError: true, DateMsg: window.NoEndDateMsg });
        }else {
            values.endDate = values.EndDatee ? this.getFromattedDate(values.EndDatee) : '';
            values.startDate = values.StartDatee ? this.getFromattedDate(values.StartDatee) : '';

            values.iServicer = userData.userId;
            this.setState({ fileType: values.fileType, isFetching: true, apiRequest: values }, () => {
                this.props.dispatch(POStatusReport.request(values));
            });
        }
    }

    getInitialValues = () => {
        return {
            startDate: null,
            endDate: null,
            fileType: 'pdf',
            reportStatus: []
        }
    }

    render() {
        let { reportGenerated, DateError, isFetching, popupTitle, popupMessage, showModal, PopupEmail, DateMsg, ShowEmailMsg } = this.state;

        let initialValues = this.getInitialValues();
        return (
            <Row className="inner-container justify-content-center pt-3">
                <LoadingDialog isOpen={isFetching}></LoadingDialog>
                <section id="claims-section" className="claims-section ">
                    {!reportGenerated ? <div className="container-fluid">
                        <Row>
                            <div className="col-12">
                                <h5 className="section-title darkcolor font-main">Purchase Order Status Report</h5>
                                <p className="font-main h5 darkcolor mt-10 mb-20">Select One or More status for your report. No selection will result in ALL status report.</p>

                                <Formik
                                    enableReinitialize={false}
                                    initialValues={initialValues}
                                    onSubmit={this.onSubmit}
                                >
                                    {function (props) {
                                        const {
                                            values,
                                            isSubmitting,
                                            handleChange,
                                            handleBlur,
                                            handleSubmit,
                                            setFieldValue
                                        } = props;
                                        return (
                                            <Form onSubmit={handleSubmit} autoComplete="off" className="form-contactus mt-4">

                                                <Row>
                                                    <div className="col-xxl-3 col-xl-4 col-lg-5 col-md-6 col-sm-10">
                                                        <Row className='mb-8'>
                                                            <FormGroup className="col-6">
                                                                <p className="font-main h5">Date From</p>
                                                                <div className="date-picker">

                                                                    <DatePicker
                                                                        id="ReportDateFrom"
                                                                        selected={values.StartDatee}
                                                                        onChange={(date) => this.setDate(date, 'StartDatee', setFieldValue)}
                                                                        className="form-control"
                                                                        maxDate={new Date()}
                                                                        value={values.StartDatee}
                                                                        onBlur={handleBlur}
                                                                        placeholderText="mm/dd/yyyy"
                                                                        name="StartDatee"
                                                                        isClearable={true}
                                                                        showMonthDropdown
                                                                        showYearDropdown
                                                                        dropdownMode="select"
                                                                    />
                                                                    <span className="noClick"><img alt="" src={require('./../../../assets/images/calender.png').default} /></span>
                                                                </div>
                                                            </FormGroup>
                                                            <FormGroup className="col-6" >
                                                                <p className="font-main h5">Date To</p>
                                                                <div className="date-picker">
                                                                    <DatePicker
                                                                        id="Reportdateto"
                                                                        selected={values.EndDatee}
                                                                        onChange={(date) => this.setDate(date, 'EndDatee', setFieldValue)}
                                                                        className="form-control"
                                                                        maxDate={new Date()}
                                                                        value={values.EndDatee}
                                                                        onBlur={handleBlur}
                                                                        placeholderText="mm/dd/yyyy"
                                                                        name="EndDatee"
                                                                        isClearable={true}
                                                                        showMonthDropdown
                                                                        showYearDropdown
                                                                        dropdownMode="select"
                                                                        autoComplete='off'
                                                                    />
                                                                    <span className="noClick"><img alt="" src={require('./../../../assets/images/calender.png').default} /></span>
                                                                </div>
                                                            </FormGroup>
                                                            {DateError ? <div className="input-error">{DateMsg}</div> : <div className="reqSubstitude"></div>}
                                                        </Row>
                                                        <FormGroup className="mb-25">
                                                            <p className="font-main h5">Select Report Type</p>
                                                            <Input id="Reportdateto1" hidden />
                                                            <Row
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                                value={values.fileType}
                                                            >
                                                                <Col md="6">
                                                                    <div className="form-check">
                                                                        <Input
                                                                            className="form-check-input pointer"
                                                                            type="radio"
                                                                            name="fileType"
                                                                            id="fileType"
                                                                            value="pdf"
                                                                            checked={values.fileType === 'pdf'}
                                                                            onChange={() => true}
                                                                        />
                                                                        <Label className="form-check-label radioCheck" for="fileType">
                                                                            PDF Report
                                                                        </Label>
                                                                    </div>
                                                                </Col>
                                                                <Col md="6">
                                                                    <div className="form-check">
                                                                        <Input
                                                                            className="form-check-input pointer"
                                                                            type="radio"
                                                                            name="fileType"
                                                                            id="fileType"
                                                                            value="csv"
                                                                            checked={values.fileType === 'csv'}
                                                                            onChange={() => true}
                                                                        />
                                                                        <Label className="form-check-label radioCheck" for="fileType">
                                                                            CSV Download
                                                                        </Label>
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                        </FormGroup>
                                                        <FormGroup className="mb-25">
                                                            <p className="font-main h5">Select Report Status</p>

                                                            <Input id="Reportstatus" hidden />
                                                            <Row
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                                value={values.reportStatus}
                                                                checked={values.reportStatus}
                                                            >
                                                                {consts.PoStatusOptions.map((status, index) => <Col md={6} lg={6} className="inlineBlock" key={index}>
                                                                    <div className="form-check">
                                                                        <Input
                                                                            className="form-check-input pointer"
                                                                            type="checkbox"
                                                                            id={status.value}
                                                                            value={status.value}
                                                                            name="reportStatus"
                                                                            defaultChecked={values.reportStatus.indexOf(status.value) !== -1}
                                                                        />
                                                                        <Label className="form-check-label radioCheck" for={status.value}>
                                                                            {status.name}
                                                                        </Label>
                                                                    </div>
                                                                </Col>)}
                                                            </Row>
                                                        </FormGroup>
                                                    </div>
                                                </Row>

                                                <button disabled={isSubmitting} type="submit" className="btn-web"> GENERATE REPORT </button>
                                            </Form>
                                        );
                                    }.bind(this)}
                                </Formik>
                            </div>
                        </Row>
                    </div> :
                        <div className="container-fluid">
                            <Row>
                                <div className="col-12">
                                    <h1 className="section-title darkcolor font-main">Purchase Order Status  Report</h1>
                                    <p className="font-main h5 darkcolor mt-10 mb-20">{ShowEmailMsg===false ? 'Your file has been downloaded. Please check your download folder on your computer.' : 'Report has been sent by email. Please check your email.' }</p>
                                    <a onClick={() => { this.setState({ reportGenerated: !reportGenerated }) }} className="pointer btn-web"> GENERATE ANOTHER REPORT  </a>
                                </div>
                            </Row>
                        </div>}
                </section>
                {showModal ? <PopupDialog
                    showModal={showModal}
                    handleModal={this.handleModal}
                    title={popupTitle}
                    message={popupMessage}
                    email={PopupEmail}
                    popupSubmit={(val) => this.popupSubmit(val)}
                /> : ''}

            </Row>
        );
    }
}

function mapStateToProps(state) {
    return {
        POStatusReport: state.POStatusReport
    };
}

var PurchaseOrderReportModule = connect(mapStateToProps)(PurchaseOrderReport);
export default PurchaseOrderReportModule;